import EstadoService from "@/api/services/finanzas/nomencladores/EstadoService"
import Vue from "vue"

const state = () => ({
    estados: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    ESTADOS: state => {
        return state.estados
    },
    ESTADOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_ESTADOS: (state, payload) => {
        state.estados = payload
    },

    SET_ESTADOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ESTADO: (state, payload) => {
        state.estados.push(payload)
    },

    UPDATE_ESTADO: (state, payload) => {
        state.estados = state.estados.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_ESTADO: (state, payload) => {
        state.estados = state.estados.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_ESTADOS: async ({ commit, state }, { filter, activo_estadoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await EstadoService.get({ filter, activo_estadoEstado, ...pagination })
            if (status === 200) {
                commit("SET_ESTADOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estados del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_ESTADOS: async ({ commit }) => {
        try {
            let { data, status } = await EstadoService.getAll()
            if (status === 200) {
                commit("SET_ESTADOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_ESTADOS: async ({ commit }) => {
        try {
            let { data, status } = await EstadoService.getAllRecords()
            if (status === 200) {
                commit("SET_ESTADOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estados del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ACTIVO_ESTADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_ESTADO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para el estado del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_ESTADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoService.post(payload)
            if (status === 201) {
                commit("ADD_ESTADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El estado ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el estado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_ESTADO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstadoService.put(payload)
            if (status === 200) {
                commit("UPDATE_ESTADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El estado ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el estado, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_ESTADO: async ({ commit }, payload) => {
        try {
            let { status, data } = await EstadoService.delete(payload)
            if (status === 204) {
                commit("DELETE_ESTADO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El estado ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_ESTADO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El estado ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el estado del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
